export class VendorRequest{
    vendorId:number;
    
    constructor(vendorId:number){
        this.vendorId = vendorId;
    }
}